import React, { useState } from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useOutageLeftPanelState } from '../../providers/OutageLeftPanelStateProvider';
import colors from '../../../../themes/main-colors';
import UserIcon from '../icons/UserIcon';
import useAuth from '../../../../hooks/useAuth';
import SignInModal from '../../../sign-in-form/SignInModal';
import routes from '../../../../routes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    expandedContainer: {
      backgroundColor: colors.riverBlue,
      cursor: 'pointer',
      padding: theme.spacing(2.5),
      borderBottom: '2px solid #d5ebf1',
    },
    expandedRow: {
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '8px',
    },
    expandedCol: {
      flexDirection: 'column',
      gap: '10px',
    },
    expandedIcon: {
      width: 32,
      height: 32,
    },
    title: {
      fontWeight: 600,
      lineHeight: '100%',
    },
    subTitle: {
      fontSize: '1rem',
      lineHeight: '100%',
    },
    collapsedContainer: {
      backgroundColor: colors.riverBlue,
      padding: theme.spacing(2.5, 0.5),
      textAlign: 'center',
      cursor: 'pointer',
    },
    collapsedTitle: {
      fontSize: '0.875rem',
      fontWeight: 600,
    },
    collapsedIcon: {
      width: 28,
      height: 28,
    },
  }),
);

export default function SignInOrRegister() {
  const classes = useStyles();
  const { panelOpen, outageMarkerView } = useOutageLeftPanelState();
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const [isLoginModalVisible, setIsLoginModalVisible] = useState<boolean>(
    false,
  );

  return (
    <>
      {panelOpen ? (
        <Grid
          container
          direction="column"
          className={classes.expandedContainer}
        >
          <Grid
            container
            item
            className={classes.expandedRow}
            wrap="nowrap"
            onClick={() => setIsLoginModalVisible(true)}
          >
            <Grid
              container
              item
              direction="column"
              className={classes.expandedCol}
            >
              <Typography variant="body1" className={classes.title}>
                {t('SIGN_IN_OR_REGISTER')}
              </Typography>
              {outageMarkerView === undefined && (
                <Typography variant="subtitle1" className={classes.subTitle}>
                  {t('SIGNIN_TO_SEE_OUTAGE')}
                </Typography>
              )}
            </Grid>
            <Grid item>
              <UserIcon size={32} />
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          direction="column"
          className={classes.collapsedContainer}
          alignItems="center"
          onClick={() => setIsLoginModalVisible(true)}
        >
          <Grid item>
            <UserIcon size={28} />
          </Grid>
          <Grid item>
            <Typography className={classes.collapsedTitle}>
              {t('SIGN_IN_OR_REGISTER')}
            </Typography>
          </Grid>
        </Grid>
      )}

      {!isAuthenticated && (
        <SignInModal
          redirectUrl={routes.OUTAGES}
          isOpen={isLoginModalVisible}
          handleClose={() => setIsLoginModalVisible(false)}
        />
      )}
    </>
  );
}
